module.exports = __webpack_public_path__ + "static/media/how-it-works-dna-report.90a4fc6c.png";